import { DataSourceEnum } from '@lunit-io/ctl-data-server';

import { dataApi } from 'src/http';
import { ClientError, ClientErrorCode } from 'src/http/client-error';
import { RemoteProjectListResp, RemoteProject } from 'src/interfaces';
import { shouldUseV3 } from 'src/utils/apiVersion';

export const getProjects = async (): Promise<RemoteProject[]> => {
  const { data } = await dataApi.get<RemoteProjectListResp>('projects/', {
    params: { sort: ['-createdAt'], page_size: 100 },
  });

  if (data.projects.length < 1) {
    throw new ClientError({ code: ClientErrorCode.NO_PROJECT_ASSIGNED });
  }

  return data.projects;
};

export const getProject = async ({
  projectId,
  dataSource,
}: {
  projectId: string;
  dataSource?: DataSourceEnum;
}): Promise<RemoteProject> => {
  const endpoint = shouldUseV3(dataSource)
    ? `v3/projects/${projectId}/`
    : `projects/${projectId}/`;
  const { data } = await dataApi.get<RemoteProject>(endpoint);
  return data;
};

type SyncProjectCurrJobIdProps = {
  projectId: string;
  jobId: string;
};

export const syncProjectCurrJobId = async ({
  projectId,
  jobId,
}: SyncProjectCurrJobIdProps): Promise<void> => {
  await dataApi.patch<RemoteProject>(`projects/${projectId}/focus/v2/`, {
    jobId,
  });
};
